// Drives the "Our Core Values" section in ./beliefs.js. Values come from Figma
// node 3777:19132 ("Values sequence") in PMG Brand; the P letter is #95C3FB by
// request rather than the Figma Bright Blue/500.
//
// background is painted on its own layer so hover can drift it; glow and edge
// are the hover highlight and border colours, dark on the pale card so they
// stay visible. width is the Figma card width over the 1280px wrapper.
export const coreValues = [
    {
        id: "partnership",
        letter: "P",
        title: "Partnership at Our Core",
        description:
            "We build genuine relationships grounded in trust, shared responsibility, and a commitment to succeeding together. Partnership means listening closely, communicating openly, and understanding that the best work is rarely done alone. We show up for our clients and each other, stay engaged in the work, and follow through on what we say we’ll do.",
        align: "left",
        letterSide: "left",
        width: "lg:w-full",
        background: "linear-gradient(90deg, #101936 0%, #182553 100%)",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        shadow: "0px 12px 28px -10px rgba(0, 0, 0, 0.08)",
        shadowHover: "0px 18px 40px -12px rgba(0, 0, 0, 0.18)",
        glow: "rgba(255, 255, 255, 0.11)",
        edge: "rgba(255, 255, 255, 0.38)",
        letterColor: "#95C3FB",
        titleColor: "#FFFFFF",
        bodyColor: "#F1F1F1",
    },
    {
        id: "purpose",
        letter: "M",
        title: "Move with Purpose",
        description:
            "We take ownership of our work and approach what we do with intention, care, and a clear understanding of what matters. We follow through on our commitments, stay focused on where we can make a meaningful difference, and take pride in both the work we produce and how we get there. Purpose keeps us thoughtful in our decisions and accountable for the role we play in moving the work forward.",
        align: "right",
        letterSide: "right",
        width: "lg:w-[87.5%]",
        background: "#204CD5",
        border: "1px solid rgba(255, 255, 255, 0.1)",
        shadow: "0px 12px 28px -10px rgba(0, 0, 0, 0.08)",
        shadowHover: "0px 18px 40px -12px rgba(0, 0, 0, 0.18)",
        glow: "rgba(255, 255, 255, 0.13)",
        edge: "rgba(255, 255, 255, 0.45)",
        letterColor: "#FFFFFF",
        titleColor: "#FFFFFF",
        bodyColor: "#F1F1F1",
    },
    {
        id: "further",
        letter: "G",
        title: "Go Further",
        description:
            "We stay curious, keep learning, and continually look for ways to make our work and its impact better. We challenge ourselves to think creatively, expand our capabilities, and bring more to every opportunity. Going further means staying open to new ideas, applying what we learn, and continually raising the standard for ourselves and the work we deliver.",
        align: "left",
        letterSide: "left",
        width: "lg:w-[93.75%]",
        background: "linear-gradient(90deg, #F8F8F8 0%, #E8EEF5 100%)",
        border: "1px solid rgba(255, 255, 255, 0.5)",
        shadow: "0px 10px 24px -10px rgba(0, 0, 0, 0.05)",
        shadowHover: "0px 16px 34px -12px rgba(0, 0, 0, 0.12)",
        glow: "rgba(24, 37, 83, 0.07)",
        edge: "rgba(24, 37, 83, 0.18)",
        letterColor: "#182553",
        titleColor: "#0F1424",
        bodyColor: "#292E3D",
    },
];
